import { ReactNode } from "react"
import RequiredMark from "./RequiredMark"

/**
 * マスタ登録項目用コンポーネント
 * label: 項目名 text
 * isRequired :必須フラグ boolean
 * width:入力項目を入れる箇所の幅
 * remarks: 備考 ReactNode
 * @param props
 * @returns
 */
const MasterRegisterFormRow: React.FC<{
  label: string
  isRequired?: boolean
  remarks?: ReactNode
  isRemarks?: boolean
  labelWidth?: number
  Width?: number
}> = (props) => {
  return (
    <div className="register-form-row">
      <div className="register-form-item">
        <div
          className={
            "register-form-label " +
            (props.labelWidth != null ? `w-${props.labelWidth}rem` : "")
          }>
          <label htmlFor={props.label}>
            {props.label}
            {props.isRequired && <RequiredMark />}
          </label>
        </div>
        <div className={`register-form-value w-${props.Width ?? 30}rem`}>
          {props.children}
        </div>
      </div>
      {props.isRemarks !== false && (
        <div className="register-form-remarks">{props.remarks}</div>
      )}
    </div>
  )
}

export default MasterRegisterFormRow
